
import React, { useState, useEffect, useRef, useLayoutEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useIntl } from 'react-intl';
import moment from 'moment';
import momentTz from 'moment-timezone';

import { TableView } from 'Components';

import "./recentAlerts.scss"

import {
    recentAlertsDashboardPanel
} from 'Redux/actions';

import alertTypes from 'Modules/alerts/common/alertTypes.json';
import { translateEvent } from '../../../.common/utils/translateEvents';

const RecentAlerts = ({ item, update }) => {
    const dispatch = useDispatch();
    const targetRef = useRef();
    const { messages, locale } = useIntl()

    const [dimensions, setDimensions] = useState({ width: 0, height: 400 });
    const [loading, setLoading] = useState(false);
    const [page, setPage] = useState(1);
    const LIMIT_PAGINATION = 25

    const {
        recentAlerts,
        loadingRecentAlerts,
        updateResponse
    } = useSelector(state => state.gadgetRecentAlertsRedux);

    const {
        user
    } = useSelector(state => state.securityRedux);

    const [dataRecentAlerts, setDataRecentAlerts] = useState([]);

    // This function calculates width and height of the list
    const getListSize = () => {
        if (targetRef.current) {
            setDimensions({
                width: targetRef.current.offsetWidth,
                height: targetRef.current.offsetHeight - 70
            });
        }
    };


    useLayoutEffect(() => {
        getListSize();
        window.addEventListener("resize", getListSize);
    }, []);

    useEffect(() => {
        setDataRecentAlerts([])
        setPage(1)
    }, [])

    useEffect(() => {
        if (update > 0) {
            let values = JSON.parse(item.settings);
            recentAlertsDashboard(values)
            setDataRecentAlerts([])
            setPage(1)
        }
    }, [update]);


    useEffect(() => {
        if (item.settings) {
            let values = JSON.parse(item.settings);
            recentAlertsDashboard(values)
            setDataRecentAlerts([])
            setPage(1)
        }
    }, [item]);

    const getValuesFilter = () => {
        let values;
        if (item.settings) {
            values = JSON.parse(item.settings);
        }
        let entities = [];
        let alertTypes = [];
        let unitTimeRange;

        if (values?.entityTags?.values) {
            entities = values.entityTags.values.map((entity) => {
              return {
                "label": values.entityTags.entity.id,
                id: entity.id,
                name: entity.name,
              }
            });
        }
        if (values?.alertType?.code && (values?.alertType?.code != "-99")) {
            alertTypes = values.alertType.code;
        }

        if (values?.timeFrame?.option?.id) {

            let start;
            let end;

            if (
                values.timeFrame.option.id === "custom" &&
                values?.timeFrame?.startDate &&
                values?.timeFrame?.endDate
            ) {
                start = values.timeFrame.startDate
                end = values.timeFrame.endDate
            } else if (values.timeFrame.option.id === "today") {
                start = moment().startOf('day').toDate()
                end = moment.max(moment()).endOf('day').toDate()

            } else if (values.timeFrame.option.id === "yesterday") {
                start = moment().subtract(1, 'days').startOf('day').toDate()
                end = moment.max(moment().subtract(1, 'days')).endOf('day').toDate()

            } else if (values.timeFrame.option.id === "week") {
                start = moment.max(moment().subtract(7, 'days')).startOf('day').toDate()
                end = moment().endOf('day').toDate()

            } else if (values.timeFrame.option.id === "lastMonth") {
                start = moment.max(moment().subtract(30, 'days')).startOf('day').toDate()
                end = moment().endOf('day').toDate()
            }

            if (start && end) {
                unitTimeRange = {
                    start,
                    end,
                }
            }

        }

        return {
            alertTypes,
            unitTimeRange,
            entities: entities,
            id: item.id,
            limit: LIMIT_PAGINATION,
            offset: 0
        }
    }

    const recentAlertsDashboard = (values) => {
        setLoading(true)
        let valuesFilter = getValuesFilter()
        let entities = []

        if(valuesFilter?.entities){
            valuesFilter?.entities?.forEach(item => {
                const {color,...value} = item
                entities.push(value)
            });
        }

        dispatch(recentAlertsDashboardPanel({ ...valuesFilter,entities }));
    }


    const handleChangePage = (newPage) => {

        if (newPage > 1) {

            let valuesFilter = getValuesFilter()
            let entities = []
            if(valuesFilter?.entities){
                valuesFilter?.entities?.forEach(item => {
                    const {color,...value} = item
                    entities.push(value)
                });
            }

            dispatch(recentAlertsDashboardPanel(
                {
                    ...valuesFilter,
                    entities,
                    offset: page * LIMIT_PAGINATION
                }
            ));

            setLoading(true)
            setPage(page + 1)
        }
    };

    const removeUnnecessaryChars = (str) => {
        return str?.replace(/\{[^()]*\}/g, '').trim()
    }

    useEffect(() => {

        if (item.settings) {

            let values = JSON.parse(item.settings);

            if (
                recentAlerts?.recentAlerts?.items &&
                (recentAlerts?.data?.id == item.id)
            ) {

                setLoading(false);
                let objectAlertTypes = {}

                alertTypes.map(alertType => {
                    objectAlertTypes[alertType.code] = alertType.name
                })

                let recentAlertsData = recentAlerts.recentAlerts.items.map((recentAlert) => {

                    let timeZone = recentAlert?.unit?.timeZone?.name || user.timeZone
                    let momentDate = momentTz(recentAlert.unitTime).tz(timeZone);

                    let date = ""
                    let time = ""
                    let alertType = ""

                    if (timeZone && momentDate) {
                        time = momentDate.format(`h:mm A`);

                        if (momentTz().tz(timeZone).isSame(momentDate, 'day')) {
                            date = messages["date_today"]
                        } else if (momentTz().tz(timeZone).subtract(1, 'd').format("DD") === momentDate.format("DD") && momentTz().tz(timeZone).subtract(1, 'd').format("MM") === momentDate.format("MM")) {
                            date = messages["date_yesterday"];
                        } else {
                            date = momentDate.format(user?.dateformat?.toUpperCase() || "D/M/Y");
                        }
                    }

                    if (
                        recentAlert?.systemAlertType &&
                        objectAlertTypes.hasOwnProperty(recentAlert.systemAlertType)
                    ) {
                        alertType = `${objectAlertTypes[recentAlert.systemAlertType]}`;

                        if (recentAlert?.config) {
                            let config = JSON.parse(recentAlert.config);
                            if (config?.name) {
                                alertType = `${config.name}`
                            }
                            if (config?.trigger) {
                                alertType = `${alertType} (${config.trigger})`
                            }
                        }
                    }

                    return {
                        type: alertType || "_",
                        unit: recentAlert?.unit?.label,
                        driver: recentAlert?.driverName,
                        time,
                        date,
                        name: recentAlert.systemAlertName,
                        severity: recentAlert.severity ? recentAlert.severity.toLowerCase() : "low"
                    }
                });

                if (recentAlerts?.data?.offset == 0) {
                    setDataRecentAlerts([...recentAlertsData]);
                } else {
                    setDataRecentAlerts([...dataRecentAlerts, ...recentAlertsData]);
                }
            }
        }
    }, [recentAlerts, locale]);


    const translateAlert = (alertName) => {
        if (!alertName || typeof alertName !== "string") return alertName;

        const partTwoTransform = alertName.toLowerCase().replace(/[^a-z0-9]/g, "");
        const translation = messages[`dashboardPanel_${partTwoTransform}`];

        return translation ?? translateEvent(alertName, messages) ?? alertName;
    };


    return (
        <div ref={targetRef}
            style={{
                overflow: 'hidden',
                height: '100%',
                width: '100%'
            }}>

            <div className='recent-alert-row-header'>
                <div className='recent-alert-cell'>
                    <span>{messages['dashboardPanel_recent_alert_type']}</span>
                </div>
                <div className='recent-alert-cell'>
                    <span>{messages['fleetView_vehicle']}</span>
                </div>
                <div className='recent-alert-cell'>
                    <span>{messages['fleetModal_time']}</span>
                </div>
            </div>

            <TableView
                name="test"
                itemSelector={false}
                serverSide
                viewType="list"
                data={dataRecentAlerts || []}
                rowsPerPage={25}
                height={`${dimensions.height + 20}px`}
                messages={messages}
                loading={loading}
                infiniteScroll={true}
                onChangePage={(newPage) => {
                    handleChangePage(newPage);
                }}
                moreRowsAvailable={true}
                renderRow={(row) => {
                    return (
                        <div className='recent-alert-row'>
                            <div style={{ paddingLeft: 20 }} className='recent-alert-cell'>
                                <span>{removeUnnecessaryChars(row.name)}</span>
                                <span>{translateAlert(row?.type)}</span>
                                <div className={`recent-alert-point ${row.severity}`} />
                            </div>
                            <div className='recent-alert-cell'>
                                <span>{row.unit ? row.unit : "_"}</span>
                                <span>{row.driver ? row.driver : "_"}</span>
                            </div>
                            <div className='recent-alert-cell'>
                                <span>{row.time}</span>
                                <span>{row.date}</span>
                            </div>
                        </div>
                    )
                }}
            >
            </TableView>
        </div>

    );
}

export default RecentAlerts;
